const sizes = {
  sm: 'w-4 h-4',
  md: 'w-8 h-8',
  lg: 'w-12 h-12'
};

export function LoadingSpinner({ size = 'md', className = '' }) {
  return (
    <div
      className={`
        animate-spin rounded-full
        border-2 border-current
        border-t-transparent
        text-cyan-500
        ${sizes[size]}
        ${className}
      `}
    />
  );
}
